import { render } from "./FilmCard.vue?vue&type=template&id=59c7e483&scoped=true"
import script from "./FilmCard.vue?vue&type=script&lang=js"
export * from "./FilmCard.vue?vue&type=script&lang=js"

import "./FilmCard.vue?vue&type=style&index=0&id=59c7e483&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-59c7e483"]])

export default __exports__